import React, { Fragment } from "react";
import styles from "./style.module.css";

const CardSkeleton = () => {
  return (
    <Fragment>
      {Array.from(Array(7).keys()).map((item) => (
        <div className={styles.skeleton} key={item}></div>
      ))}
    </Fragment>
  );
};

export default CardSkeleton;
